import React from 'react';

const Camera = () => {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13.5002" cy="12.675" r="12.175" fill="white" stroke="#E9ECF0" />
      <g clipPath="url(#clip0_693_23297)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8252 16.6557C13.0139 16.6548 12.2361 16.3321 11.6624 15.7584C11.0887 15.1847 10.766 14.4068 10.7651 13.5955C10.7658 12.7841 11.0885 12.0061 11.6622 11.4323C12.2359 10.8585 13.0138 10.5357 13.8252 10.5348C14.6367 10.5357 15.4146 10.8585 15.9883 11.4323C16.562 12.0061 16.8846 12.7841 16.8854 13.5955C16.8845 14.4068 16.5618 15.1847 15.9881 15.7584C15.4144 16.3321 14.6366 16.6548 13.8252 16.6557ZM18.5578 8.99594H16.8347L16.1854 7.73069C16.0825 7.53039 15.9263 7.36235 15.734 7.24504C15.5418 7.12772 15.3209 7.06566 15.0957 7.06569H12.5215C12.2918 7.06567 12.0668 7.13019 11.8721 7.25189C11.6774 7.3736 11.5208 7.5476 11.4202 7.75403L10.8158 8.99594H9.09265C8.89956 8.99587 8.70835 9.03383 8.52993 9.10767C8.35151 9.18151 8.18939 9.28978 8.05283 9.42629C7.91627 9.5628 7.80793 9.72488 7.73402 9.90326C7.66011 10.0817 7.62207 10.2729 7.62207 10.4659V17.2332C7.62207 17.4263 7.66011 17.6175 7.73402 17.7959C7.80793 17.9743 7.91627 18.1363 8.05283 18.2728C8.18939 18.4094 8.35151 18.5176 8.52993 18.5915C8.70835 18.6653 8.89956 18.7033 9.09265 18.7032H18.5578C18.7509 18.7033 18.9421 18.6653 19.1205 18.5915C19.299 18.5176 19.4611 18.4094 19.5976 18.2728C19.7342 18.1363 19.8425 17.9743 19.9165 17.7959C19.9904 17.6175 20.0284 17.4263 20.0284 17.2332V10.4659C20.0284 10.2729 19.9904 10.0817 19.9165 9.90326C19.8425 9.72488 19.7342 9.5628 19.5976 9.42629C19.4611 9.28978 19.299 9.18151 19.1205 9.10767C18.9421 9.03383 18.7509 8.99587 18.5578 8.99594Z"
          fill="#5C6983"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8256 11.6368C13.3067 11.6374 12.8091 11.8439 12.4422 12.2109C12.0753 12.5779 11.869 13.0755 11.8685 13.5945C11.8688 14.1135 12.0751 14.6112 12.4421 14.9782C12.809 15.3453 13.3066 15.5517 13.8256 15.5522C14.3446 15.5517 14.8422 15.3453 15.2092 14.9782C15.5761 14.6112 15.7824 14.1135 15.7827 13.5945C15.7822 13.0755 15.5759 12.5779 15.209 12.2109C14.8421 11.8439 14.3446 11.6374 13.8256 11.6368Z"
          fill="#5C6983"
        />
      </g>
      <defs>
        <clipPath id="clip0_693_23297">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(6.8252 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Camera;
